import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { fieldsWrapperStyle } from 'components/layout/styles';

interface IProps {
  className?: string;
  children?: ReactNode;
  id?: string;
  onSubmit?: (e: any) => void;
}

const StyledFormWrapper = ({ className, children, ...rest }: IProps) => {
  return (
    <FormWrapper className={className} {...rest}>
      {children}
    </FormWrapper>
  );
};

export default StyledFormWrapper;

const FormWrapper = styled.form`
  width: 100%;
  ${fieldsWrapperStyle};
`;
